import RequestStatus from 'types/general/requests/RequestStatus';
import IOrder from 'types/backend_models/orders/IOrder';
import { createSlice } from '@reduxjs/toolkit';
import { GenericDataState, createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer } from '../generic/GenericDataReducers';

/* GENERIC */
const initialState: GenericDataState<IOrder | null> = {
    requestStatus: RequestStatus.idle,
    data: null,
    error: null
};

/* SLICE */
const slice = createSlice({
    name: "order",
    initialState: initialState,
    reducers: {
        setFetchOrderPending: createSetFetchDataPendingReducer(),
        setFetchOrderSucces: createSetFetchDataSuccesReducer(),
        setFetchOrderError: createSetFetchDataErrorReducer()
    }
});

export const {
    setFetchOrderPending,
    setFetchOrderSucces,
    setFetchOrderError
} = slice.actions;

export default slice.reducer;

/* NON  GENERIC */
/* DEFAULT STATE & TYPES */
// interface IOrderDataState extends IDefaultRequestProps {
//     order: IOrder | null
// };

// const defaultState: IOrderDataState = {
//     requestStatus: RequestStatus.idle,
//     order: null,
//     error: null
// };


// /* REDUCERS */
// const setFetchOrderPendingReducer: CaseReducer<IOrderDataState> = (state: IOrderDataState) => {
//     state.requestStatus = RequestStatus.pending;
//     state.order = null;
//     state.error = null;
// };
// const setFetchOrderSuccesReducer: CaseReducer<IOrderDataState, PayloadAction<{ order: IOrder }>> = (state: IOrderDataState, action) => {
//     state.requestStatus = RequestStatus.succes;
//     state.order = action.payload.order;
// };
// const setFetchOrderErrorReducer: CaseReducer<IOrderDataState, PayloadAction<{ error: string }>> = (state: IOrderDataState, action) => {
//     state.requestStatus = RequestStatus.error;
//     state.order = null;
//     state.error = action.payload.error;
// };

// /* SLICE */
// const orderSlice = createSlice({
//     name: "order",
//     initialState: defaultState,
//     reducers: {
//         setFetchOrderPending: setFetchOrderPendingReducer,
//         setFetchOrderSucces: setFetchOrderSuccesReducer,
//         setFetchOrderError: setFetchOrderErrorReducer
//     }
// });

// export const {
//     setFetchOrderPending,
//     setFetchOrderSucces,
//     setFetchOrderError
// } = orderSlice.actions;

// export default orderSlice.reducer;


/* DEPRECATED REDUCER */

// export function orderDataReducer(state = defaultState, action: TOrderDataActionTypes): IOrderDataState {
//     switch (action.type) {
//         case FETCH_ORDER_PENDING: {
//             return {
//                 ...state,
//                 requestStatus: RequestStatus.pending,
//                 order: null,
//                 error: null
//             };
//         }
//         case FETCH_ORDER_SUCCESS: {
//             return {
//                 ...state,
//                 requestStatus: RequestStatus.succes,
//                 order: action.order
//             }
//         }
//         case FETCH_ORDER_ERROR: {
//             return {
//                 ...state,
//                 requestStatus: RequestStatus.error,
//                 error: action.error
//             }
//         }
//         default: {
//             return state;
//         }
//     }
// }

// export default orderDataReducer;

/* DEPRECATED REDUCER
export function ordersingle(
    state = {
        data: {},
        line: {},
        lines: [],
        isneworder: false,
        fetch: {
            success: false,
            pending: false,
            error: null,
            linessuccess: false,
            linespending: false,
            lineserror: null,
            linesuccess: false,
            linepending: false,
            lineerror: null,
        },
        post: {
            success: false,
            pending: false,
            error: null,
            linesuccess: false,
            linepending: false,
            lineerror: null,
        },
        update: {
            success: false,
            pending: false,
            error: null,
            linesuccess: false,
            linepending: false,
            lineerror: null,
            statussuccess: false,
            statuspending: false,
            statuserror: null,
        },
        delete: {
            success: false,
            pending: false,
            error: null,
            linesuccess: false,
            linepending: false,
            lineerror: null,
        }
    }, action) {
    switch (action.type) {
        case Types.FETCH_ORDER_SINGLE_PENDING:
            return {
                ...state,
                fetch: {
                    ...state.fetch,
                    pending: true,
                }
            }
            case Types.FETCH_ORDER_SINGLE_SUCCESS:
                return {
                    ...state,
                    fetch: {
                            ...state.fetch,
                            pending: false,
                            success: true,
                        },
                        data: action.data,
                }
                case Types.FETCH_ORDER_SINGLE_ERROR:
                    return {
                        ...state,
                        fetch: {
                            success: false,
                            pending: false,
                            error: action.data,
                        },
                    }
                    case Types.POST_ORDER_PENDING:
                        return {
                            ...state,
                            post: {
                                ...state.post,
                                pending: true,
                            }
                        }
                        case Types.POST_ORDER_SUCCESS:
                            return {
                                ...state,
                                data: action.data,
                                    isneworder: false,
                                    post: {
                                        ...state.post,
                                        pending: false,
                                        success: true,
                                        error: null,
                                    }
                            }
                            case Types.POST_ORDER_ERROR:
                                return {
                                    ...state,
                                    post: {
                                        ...state.post,
                                        pending: false,
                                        success: false,
                                        error: action.error,
                                    }
                                }
                                case Types.POST_ORDER_PREPARE:
                                    return {
                                        ...state,
                                        isneworder: true,
                                            data: {
                                                statusId: 'ne'
                                            }, //action.data, //{}, //{contactStatusId:'ac'},
                                            post: {
                                                ...state.post,
                                                success: false,
                                            },
                                    }
                                    case Types.DELETE_ORDER_PENDING:
                                        return {
                                            ...state,
                                            delete: {
                                                ...state.delete,
                                                pending: true,
                                            }
                                        }
                                        case Types.DELETE_ORDER_SUCCESS:
                                            return {
                                                ...state,
                                                delete: {
                                                    ...state.delete,
                                                    pending: false,
                                                    success: true,
                                                    error: null,
                                                    data: action.data,
                                                }
                                            }
                                            case Types.DELETE_ORDER_ERROR:
                                                return {
                                                    ...state,
                                                    delete: {
                                                        ...state.delete,
                                                        pending: false,
                                                        success: false,
                                                        error: action.data,
                                                    }
                                                }
                                                case Types.UPDATE_ORDER_PENDING:
                                                    return {
                                                        ...state,
                                                        update: {
                                                            ...state.update,
                                                            pending: true,
                                                        }
                                                    }
                                                    case Types.UPDATE_ORDER_SUCCESS:
                                                        return {
                                                            ...state,
                                                            data: action.data,
                                                                update: {
                                                                    ...state.update,
                                                                    pending: false,
                                                                    success: true,
                                                                    error: null,
                                                                },
                                                        }
                                                        case Types.UPDATE_ORDER_ERROR:
                                                            return {
                                                                ...state,
                                                                update: {
                                                                    ...state.update,
                                                                    pending: false,
                                                                    success: false,
                                                                    error: true,
                                                                    message: action.error || action.message,
                                                                }
                                                            }
                                                            case Types.CLEAR_ORDER_SUCCESS:
                                                                return {
                                                                    ...state,
                                                                    isneworder: false,
                                                                        data: {},
                                                                        fetch: {
                                                                            ...state.fetch,
                                                                            success: false,
                                                                            linessuccess: false,
                                                                        },
                                                                        post: {
                                                                            ...state.post,
                                                                            success: false,
                                                                        },
                                                                        update: {
                                                                            ...state.update,
                                                                            success: false,
                                                                        },
                                                                        delete: {
                                                                            ...state.delete,
                                                                            success: false,
                                                                        },
                                                                }
                                                                case Types.FETCH_ORDER_LINES_PENDING:
                                                                    return {
                                                                        ...state,
                                                                        fetch: {
                                                                            ...state.fetch,
                                                                            linespending: true,
                                                                        }
                                                                    }
                                                                    case Types.FETCH_ORDER_LINES_SUCCESS:
                                                                        return {
                                                                            ...state,
                                                                            fetch: {
                                                                                    ...state.fetch,
                                                                                    linespending: false,
                                                                                    linessuccess: true,
                                                                                },
                                                                                lines: action.data,
                                                                        }
                                                                        case Types.FETCH_ORDER_LINES_ERROR:
                                                                            return {
                                                                                ...state,
                                                                                fetch: {
                                                                                    ...state.fetch,
                                                                                    linessuccess: false,
                                                                                    // linespending: false,
                                                                                    error: action.data,
                                                                                },
                                                                            }
                                                                            case 'FETCH_ORDER_LINES_CLEANUP':
                                                                                return {
                                                                                    ...state,
                                                                                    fetch: {
                                                                                            ...state.fetch,
                                                                                            linessuccess: false,
                                                                                            linespending: false,
                                                                                        },
                                                                                        lines: [],
                                                                                }
                                                                                // Fetch Order Line
                                                                                case 'FETCH_ORDER_LINE_PENDING':
                                                                                    return {
                                                                                        ...state,
                                                                                        fetch: {
                                                                                            ...state.fetch,
                                                                                            linepending: true,
                                                                                        },
                                                                                    }
                                                                                    case 'FETCH_ORDER_LINE_SUCCESS':
                                                                                        return {
                                                                                            ...state,
                                                                                            line: action.data,
                                                                                                fetch: {
                                                                                                    ...state.fetch,
                                                                                                    linepending: false,
                                                                                                    linesuccess: true,
                                                                                                },
                                                                                        }
                                                                                        case 'FETCH_ORDER_LINE_ERROR':
                                                                                            return {
                                                                                                ...state,
                                                                                                fetch: {
                                                                                                    ...state.fetch,
                                                                                                    linepending: false,
                                                                                                    linesuccess: false,
                                                                                                    lineerror: action.data,
                                                                                                },
                                                                                            }
                                                                                            // Post Order Line
                                                                                            case 'POST_ORDER_LINE_PENDING':
                                                                                                return {
                                                                                                    ...state,
                                                                                                    post: {
                                                                                                        ...state.post,
                                                                                                        linepending: true,
                                                                                                    },
                                                                                                }
                                                                                                case 'POST_ORDER_LINE_SUCCESS':
                                                                                                    return {
                                                                                                        ...state,
                                                                                                        post: {
                                                                                                                ...state.post,
                                                                                                                linepending: false,
                                                                                                                linesuccess: true,
                                                                                                            },
                                                                                                            fetch: {
                                                                                                                ...state.fetch,
                                                                                                                linessuccess: false, //to trigger re-render of orderlinetable
                                                                                                            }
                                                                                                    }
                                                                                                    case 'POST_ORDER_LINE_ERROR':
                                                                                                        return {
                                                                                                            ...state,
                                                                                                            post: {
                                                                                                                ...state.post,
                                                                                                                linepending: false,
                                                                                                                linesuccess: false,
                                                                                                                lineerror: action.data,
                                                                                                            },
                                                                                                        }

                                                                                                        // Update Order Line
                                                                                                        case 'UPDATE_ORDER_LINE_PENDING':
                                                                                                            return {
                                                                                                                ...state,
                                                                                                                update: {
                                                                                                                    ...state.update,
                                                                                                                    linepending: true,
                                                                                                                },
                                                                                                            }
                                                                                                            case 'UPDATE_ORDER_LINE_SUCCESS':
                                                                                                                return {
                                                                                                                    ...state,
                                                                                                                    line: action.data,
                                                                                                                        update: {
                                                                                                                            ...state.update,
                                                                                                                            linepending: false,
                                                                                                                            linesuccess: true,
                                                                                                                        },
                                                                                                                        fetch: {
                                                                                                                            ...state.fetch,
                                                                                                                            linessuccess: false, //to trigger re-render of orderlinetable
                                                                                                                        }
                                                                                                                }
                                                                                                                case 'UPDATE_ORDER_LINE_ERROR':
                                                                                                                    return {
                                                                                                                        ...state,
                                                                                                                        update: {
                                                                                                                            ...state.update,
                                                                                                                            linepending: false,
                                                                                                                            linesuccess: false,
                                                                                                                            lineerror: action.data,
                                                                                                                        },
                                                                                                                    }
                                                                                                                    // Delete Order Line
                                                                                                                    case 'DELETE_ORDER_LINE_PENDING':
                                                                                                                        return {
                                                                                                                            ...state,
                                                                                                                            delete: {
                                                                                                                                ...state.delete,
                                                                                                                                linepending: true,
                                                                                                                            },
                                                                                                                        }
                                                                                                                        case 'DELETE_ORDER_LINE_SUCCESS':
                                                                                                                            return {
                                                                                                                                ...state,
                                                                                                                                delete: {
                                                                                                                                        ...state.delete,
                                                                                                                                        linepending: false,
                                                                                                                                        linesuccess: true,
                                                                                                                                    },
                                                                                                                                    fetch: {
                                                                                                                                        ...state.fetch,
                                                                                                                                        linessuccess: false, //to trigger re-render of orderlinetable
                                                                                                                                    }
                                                                                                                            }
                                                                                                                            case 'DELETE_ORDER_LINE_ERROR':
                                                                                                                                return {
                                                                                                                                    ...state,
                                                                                                                                    delete: {
                                                                                                                                        ...state.delete,
                                                                                                                                        linepending: false,
                                                                                                                                        linesuccess: false,
                                                                                                                                        lineerror: action.data,
                                                                                                                                    },
                                                                                                                                }
                                                                                                                                // *** New Order Line Dialog Open  ***
                                                                                                                                case 'DIALOG_ORDER_LINE_OPEN_NEW':
                                                                                                                                    return {
                                                                                                                                        ...state,
                                                                                                                                        line: action.data, //orderId,
                                                                                                                                    }
                                                                                                                                    // *** Order Line Dialog Cleanup ***
                                                                                                                                    case 'DIALOG_ORDER_LINE_CLOSE':
                                                                                                                                        return {
                                                                                                                                            ...state,
                                                                                                                                            line: {},
                                                                                                                                                fetch: {
                                                                                                                                                    ...state.fetch,
                                                                                                                                                    linepending: false,
                                                                                                                                                    linesuccess: false,
                                                                                                                                                }
                                                                                                                                        }
                                                                                                                                        //Update Order Status
                                                                                                                                        case 'UPDATE_ORDER_STATUS_PENDING':
                                                                                                                                            return {
                                                                                                                                                ...state,
                                                                                                                                                update: {
                                                                                                                                                    ...state.update,
                                                                                                                                                    statuspending: true,
                                                                                                                                                }
                                                                                                                                            }
                                                                                                                                            case 'UPDATE_ORDER_STATUS_SUCCESS':
                                                                                                                                                return {
                                                                                                                                                    ...state,
                                                                                                                                                    update: {
                                                                                                                                                            ...state.update,
                                                                                                                                                            statuspending: false,
                                                                                                                                                            statussuccess: true,
                                                                                                                                                        },
                                                                                                                                                        // data: action.data
                                                                                                                                                }
                                                                                                                                                case 'UPDATE_ORDER_STATUS_ERROR':
                                                                                                                                                    return {
                                                                                                                                                        ...state,
                                                                                                                                                        update: {
                                                                                                                                                            ...state.update,
                                                                                                                                                            statuspending: false,
                                                                                                                                                            statussuccess: false,
                                                                                                                                                            statuserror: action.data,
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    case 'UPDATE_ORDER_STATUS_CLEANUP':
                                                                                                                                                        return {
                                                                                                                                                            ...state,
                                                                                                                                                            update: {
                                                                                                                                                                ...state.update,
                                                                                                                                                                statuspending: false,
                                                                                                                                                                statussuccess: false,
                                                                                                                                                                statuserror: null,
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        default:
                                                                                                                                                            return state;
    }
}
*/